import { useEffect, useState } from "react";
import api from "@api";

function Frontend() {
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    const fetchOrg = async () => {
      try {
        const response = await api.get("/api/organizations");
        setOrganizations(response.data.organizations || []);
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };
    fetchOrg();
  }, []);

  // ✅ Helper function to build URL
  const getOrgUrl = (org) => {
    if (org.domain) {
      return `https://${org.domain}`; // ✅ FULL custom domain
    } else if (org.slug) {
      return `${window.location.origin}/${org.slug}`; // ✅ fallback to slug on current domain
    } else {
      return "#";
    }
  };

console.log(organizations)
  return (
    <div className="Frontend_container">
      <h2>All Listings</h2>
      {organizations
        .filter(org => org.id !== 2)
        .map(org => {
          const hasNonSuperAdmin = org.users?.some(user => user.role !== 'super_admin');
          return hasNonSuperAdmin && (
            <div key={org.id}>
              <a
                href={getOrgUrl(org)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {org.name}
              </a>
            </div>
          );
        })}


    </div>
  );

}

export default Frontend;
